import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import axios from "axios"


let cancelToken;

const getSurveyReport = (classId, reportMode, template = "", surveyId = "") => {
  cancelToken = getAxiosCancelToken(cancelToken);
  // return apiRequestType(
  //   apiTypes.GET,
  //   apiConstants.REPORT.SURVEY_REPORT.GET_SURVEY_REPORT(classId, reportMode),
  //   cancelToken
  // );

  if (reportMode === "View") {
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.SURVEY_REPORT.GET_SURVEY_REPORT(classId, reportMode),
      "",
      cancelToken
    );
  } 
  else if(template === "UserScoredSurveyReport"){
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.SURVEY_REPORT.GET_SURVEY_REPORT(
          classId,
          reportMode,
          template,
          surveyId
        )
      );    
      // const excelUrl = `${apiConstants.BASE_URL_1}/${apiConstants.REPORT.CSV_REPORT(encodeURIComponent(url), template)}`;
      const excelUrl = `${apiConstants.BASE_URL_1}/api/v1/Download/Export?url=${encodeURIComponent(url)}&template=${template}`;
      // Determine the appropriate authentication header
      const securityProviderName = localStorage.getItem("SecurityProviderName");
      let headers = {
          TenantSlugName: localStorage.getItem("tenantName"),
      };
      console.log("excelUrl", excelUrl);
      if (securityProviderName === "aad") {
      headers.Authorization = localStorage.getItem("token");
      } else {
      headers.AuthenticationToken = localStorage.getItem("token");
      }
      return axios.get(excelUrl, {
          responseType: 'blob', // Ensure the response is treated as binary data
          headers: headers
        });    
  }
  else {
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.SURVEY_REPORT.GET_SURVEY_REPORT(
          classId,
          reportMode,
          template,
          surveyId
        )
      );
    // let template = "";
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.CSV_SURVEY_REPORT(url, template),
      "",
      cancelToken
    );
  }
};

export default getSurveyReport;
